module.exports = __webpack_public_path__ + "media/images/new_home/edit-icon-0cf35b60d41d249a41e87991ea32e7f7.png";